<template>
    <ModelEditLayout
        :indexRoute="$route('admin::departments.index')"
        :updateRoute="$route('admin::departments.update', { department: department.id })"
        :modelNameSingular="__('admin::departments.department')"
        :modelNamePlural="__('admin::departments.departments')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.email')" :error="errors.email">
            <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.phone')" :error="errors.phone">
            <Input name="phone" type="text" :has-error="exists(errors.phone)" v-model="form.phone" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.address')" :error="errors.address">
            <Input name="address" type="text" :has-error="exists(errors.address)" v-model="form.address" :required="false" />
        </FormGroup>

        <div class="grid grid-cols-2 gap-4">
            <FormGroup :label="__('admin::labels.zipcode')" :error="errors.zipcode">
                <Input name="zipcode" type="text" :has-error="exists(errors.zipcode)" v-model="form.zipcode" :required="false" />
            </FormGroup>

            <FormGroup :label="__('admin::labels.city')" :error="errors.city">
                <Input name="city" type="text" :has-error="exists(errors.city)" v-model="form.city" :required="false" />
            </FormGroup>
        </div>

        <FormGroup :label="__('admin::labels.country')" :error="errors.country">
            <Select name="country" :options="countryOptions" :has-error="exists(errors.country)" v-model="form.country" :required="false" />
        </FormGroup>

    </ModelEditLayout>
</template>

<script>
    import ModelEditLayout from '@/Layouts/ModelEditLayout'
    import FormGroup from "@/Components/FormGroup";
    import Input from "@/Components/Input";
    import Select from "@/Components/Select";

    export default {
        components: {
            Select,
            Input,
            FormGroup,
            ModelEditLayout,
        },
        props: {
            errors: Object,
            department: Object,
            countryOptions: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.department.name,
                    email: this.department.email,
                    phone: this.department.phone,
                    address: this.department.address,
                    zipcode: this.department.zipcode,
                    city: this.department.city,
                    country: this.department.country,
                })
            }
        },
    }
</script>
